// extracted by mini-css-extract-plugin
export var block = "Content-module--block--0e81d";
export var bottomValign = "Content-module--bottom--valign--8393c";
export var centerAlign = "Content-module--center--align--83ee4";
export var centerValign = "Content-module--center--valign--2c6f9";
export var clamp = "Content-module--clamp--09819";
export var content = "Content-module--content--cdac5";
export var deep = "Content-module--deep--93741";
export var leftAlign = "Content-module--left--align--18f6a";
export var lgPad = "Content-module--lg--pad--ad3ad";
export var mdPad = "Content-module--md--pad--469ce";
export var rightAlign = "Content-module--right--align--e980e";
export var topValign = "Content-module--top--valign--81633";
export var whiteBox = "Content-module--white-box--37371";
export var xlPad = "Content-module--xl--pad--0cf61";